export function createContentProxy<T extends object>(content: T): T {
  const groupCache = new Map<string, unknown>();
  return new Proxy(content, {
    get(target, groupName, receiver) {
      if (typeof groupName === "symbol")
        return Reflect.get(target, groupName, receiver);
      const cached = groupCache.get(groupName);
      if (cached !== undefined) return cached;
      const group =
        (Reflect.get(target, groupName, receiver) as
          | Record<string, unknown>
          | undefined) ?? {};
      const proxy = new Proxy(group, {
        get(groupTarget, fieldName, groupReceiver) {
          if (typeof fieldName === "symbol")
            return Reflect.get(groupTarget, fieldName, groupReceiver);
          const key: string = fieldName;
          const value = groupTarget[key];
          return value !== undefined && value !== "" ? value : key;
        },
      });
      groupCache.set(groupName, proxy);
      return proxy;
    },
  });
}

export function createImageProxy<T extends object>(image: T): T {
  const groupCache = new Map<string, unknown>();
  return new Proxy(image, {
    get(target, groupName, receiver) {
      if (typeof groupName === "symbol")
        return Reflect.get(target, groupName, receiver);
      const cached = groupCache.get(groupName);
      if (cached !== undefined) return cached;
      const group =
        (Reflect.get(target, groupName, receiver) as
          | Record<string, unknown>
          | undefined) ?? {};
      const proxy = new Proxy(group, {
        get(groupTarget, key, groupReceiver) {
          if (typeof key === "symbol")
            return Reflect.get(groupTarget, key, groupReceiver);
          const k: string = key;
          return groupTarget[k] ?? {};
        },
      });
      groupCache.set(groupName, proxy);
      return proxy;
    },
  });
}

export function createSliderProxy<T extends object>(slider: T): T {
  const groupCache = new Map<string, unknown>();
  return new Proxy(slider, {
    get(target, groupName, receiver) {
      if (typeof groupName === "symbol")
        return Reflect.get(target, groupName, receiver);
      const value = Reflect.get(target, groupName, receiver);
      if (value !== undefined) return value;
      const cached = groupCache.get(groupName);
      if (cached !== undefined) return cached;
      const fallback: unknown[] = [];
      groupCache.set(groupName, fallback);
      return fallback;
    },
  });
}
